module.exports = __webpack_public_path__ + "img/downer_light_rail.0f9362e6.jpg";